import React, {useContext, useEffect, useState} from "react"
import UserContext from "../../../context/UserContext"
import Button from "../../common/Button";
import AuthorizeAction from "../AuthorizeAction"
import Advertising from "../../Advertising";
import styled from "styled-components";


const WelcomeContainer = () => {
    const [authStart, setAuthStart] = useState(false)
    const {acceptRules} = useContext(UserContext)

    const handlerBackBtn = () => setAuthStart(false)

    const handlerInetBtn = () => setAuthStart(true)
    useEffect(()=>{
        localStorage.removeItem("_wh_call")
    },[])
    return <>
        {
            authStart === false
                ? <Button
                    onClick={handlerInetBtn}
                    text={"Войти в Интернет"}
                    idPhrase={"btn_auth"}
                    disabled={!acceptRules}
                />
                : <AuthorizeAction handlerBackBtn={handlerBackBtn}/>
        }
    </>
}

export default WelcomeContainer